import React, { lazy } from "react";

export function lazyWithRetry<T>(
  componentImport: () => Promise<{ default: (props: T) => React.ReactNode }>
) {
  const { NODE_ENV } = import.meta.env;
  const isProd = NODE_ENV === "production";

  return lazy(async () => {
    try {
      const component = await componentImport();

      return component;
    } catch (error) {
      if (isProd) {
        window.location.reload();

        return {
          default: () => (
            <div className="container">
              <p className="text">Memproses fitur, harap tunggu</p>
              <div className="loader" />
            </div>
          ),
        };
      }

      throw error;
    }
  });
}
